import { Formaters } from "../utils/Formaters";

type InterpolationElement = HTMLElement & {
    $componentUpdated?: () => void
    $destroy?: () => void
}

const navigate = (event: Event) => {
    event.preventDefault();
    return navigateTo(event.target.attributes.href.value);
}

const addListeners = (links: HTMLAnchorElement[]) => {
    links.forEach((link) => {
        const localePath = useLocalePath();
        const attr = link.getAttribute('route-data') as string;
        const json = atob(attr);
        const data: any = JSON.parse(json);
        link.href = localePath({ name: 'content-slug', params: { slug: data.slug } });
        link.addEventListener('click', navigate, false);
    })
}

const removeListeners = (links: HTMLAnchorElement[]) => {
    links.forEach((link) => {
        link.removeEventListener('click', navigate, false)
    })
}

const formaters = new Formaters();

export default defineNuxtPlugin((nuxtApp: NuxtApp) => {
    console.log('[Interpolate]: Init.');
    nuxtApp.vueApp.directive('interpolate', {
        mounted(el: InterpolationElement, binding: any) {
            const links = Array.from(el.querySelectorAll('a[route-data]')) as HTMLAnchorElement[];
            const paths = Array.from(el.querySelectorAll('span[path-data]')) as HTMLSpanElement[];

            addListeners(links);

            const obj = {
                company: nuxtApp.$client.settings.company.contacts.find((contact: any) => contact.culture === nuxtApp.$client.settings.language && contact.countryCode === nuxtApp.$client.settings.country),
                context: {
                    ...binding.value
                }
            };

            paths.forEach((span) => {
                const path = span.getAttribute('path-data')?.split('.');
                let result = obj as any;

                path?.forEach((p: string) => {
                    if (p.includes(' | ')) {
                        const parts = p.split(' | ');
                        const property: string = parts[0];
                        const format: string = parts[1];
                        const value: string = result[property] as string;

                        result = formaters[format](value);
                    } else {
                        result = result[p];
                    }
                });

                span.innerHTML = result;
            });

            // cleanup
            el.$componentUpdated = () => {
                removeListeners(links)
                nextTick(() => addListeners(links));
            }
            el.$destroy = () => removeListeners(links);
        },
        updated: (el: InterpolationElement) => el.$componentUpdated?.(),
        beforeUnmount: (el: InterpolationElement) => el.$destroy?.()
    });
});